export enum OnboardingLadderStepId {
  CONNECT_SHOPIFY = 'connect_shopify',
  INSTALL_TRACKING = 'install_tracking',
  CONNECT_FACEBOOK_SOURCE = 'connect_facebook_source',
  ENABLE_FACEBOOK_DESTINATION = 'enable_facebook_destination',
  SHOPIFY_DATA_SHARING_OFF = 'shopify_data_sharing_off',
  CONNECT_KLAVIYO = 'connect_klaviyo',
  KLAVIYO_FLOWS = 'klaviyo_flows',
  CONNECT_GOOGLE_SOURCE = 'connect_google_source',
  ENABLE_GOOGLE_DESTINATION = 'enable_google_destination',
}
export enum OnboardingLadderStepState {
  COMPLETE = 'complete',
  CURRENT = 'current',
  UPCOMING = 'upcoming',
  COMING_SOON = 'coming_soon',
}
